// extracted by mini-css-extract-plugin
export default {"icon":"DocumentationIcon_icon__sSl7S"};